import { Box, CircularProgress } from '@mui/material';
import { theme } from 'theme/theme';

const Spinner = () => {
  return (
    <Box height={'100%'} position={'absolute'} left={'50%'} top={'45%'}>
      <CircularProgress sx={{ color: theme.palette.secondary.main }} />
    </Box>
  );
};

export default Spinner;
